import script from "./PermissionsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionsPage.vue?vue&type=script&setup=true&lang=js"

import "./PermissionsPage.vue?vue&type=style&index=0&id=2ac09c35&scoped=true&lang=css"

import exportComponent from "/opt/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ac09c35"]])

export default __exports__